import { render, staticRenderFns } from "./AccountSettingNotification.vue?vue&type=template&id=f9fb4a3c"
import script from "./AccountSettingNotification.vue?vue&type=script&lang=js"
export * from "./AccountSettingNotification.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingNotification.vue?vue&type=style&index=0&id=f9fb4a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports